import TipContext from '@/pages/home/components/TipContext';
import EllipsisText from '@gp/components/EllipsisText';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import LinkJump from '@gp/components/LinkJump';
import {
  getStudioJumpUrlCrossSystem,
  getStudioJumpable,
  handleStudioJumpCrossSystem,
} from '@gp/pages/StudioDashboard/StudioOverall/utils';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import React from 'react';
import { Col, Form, Row } from 'tea-component';
import './index.scss';

export default function TeamInformation(props: any) {
  const { gameInformationData } = props;

  const renderFormItemLabel = (label: string, icon?: string, info = '') => {
    return (
      <span className="game-information-form-label">
        {/* {icon && (
          <img className="game-information-form-label-icon" src={FIELD_ICONS[icon?.toLowerCase()]} alt="" />
        )} */}
        <span className="game-information-form-label-text">{label}</span>
        {info && <TipContext tipText={info} className="game-information-form-label-icon" />}
      </span>
    );
  };

  const studioJumpSystem = gameInformationData?.studio_jump;
  const studioJumpable = getStudioJumpable(studioJumpSystem);
  const studioJumpUrl = getStudioJumpUrlCrossSystem({
    studioJump: studioJumpSystem,
    studioId: gameInformationData?.studio_entity_id,
    studioName: gameInformationData?.studio,
  });

  return (
    <>
      <Form readonly className="font14 dbg-projectdetails-gameinfo-form">
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Studio', 'file')}>
              <LinkJump url={studioJumpUrl}>
                <span
                  style={{
                    color: studioJumpable ? '#326ff0' : '',
                    cursor: studioJumpable ? 'pointer' : 'normal',
                  }}
                  onClick={(e) => {
                    handleStudioJumpCrossSystem(studioJumpSystem, studioJumpUrl, e);
                  }}
                >
                  <EllipsisTextBubble text={gameInformationData.studio || '-'} />
                </span>
              </LinkJump>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Studio Location', 'file')}>
              <EllipsisText
                overShowBubble={true}
                text={gameInformationData.studio_location || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Team Size', 'file')}>
              <EllipsisText
                overShowBubble={true}
                text={dataFormat({ value: gameInformationData.team_size, formatRule: 'int' })}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('P-team', 'file')}>
              <EllipsisText
                overShowBubble={true}
                text={gameInformationData.pteam || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={renderFormItemLabel('Publishing Team', 'file')}>
              <EllipsisText
                overShowBubble={true}
                text={gameInformationData.publisher || '-'}
                lineNum={1}
                textSize={14}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
